import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { I18nModule } from "@spartacus/core";

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [I18nModule]
})
export class LoaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
